<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="close()">
  {{ data().title }}
</aionz-header-bottom-sheet>

<aionz-dialog-content class="dialog-content">
  <div class="meta-section">
    <div class="meta-item">
      <span class="meta-label">Status</span>
      <aionz-purchase-request-status
        [status]="data().requestStatus"></aionz-purchase-request-status>
    </div>
    <div class="meta-item">
      <span class="meta-label">Solicitação</span>
      <aionz-kanban-chip-badge
        [label]="'#' + data().purchaseId"
        [compact]="true">
      </aionz-kanban-chip-badge>
    </div>
    <div class="meta-item">
      <span class="meta-label">Fornecedores</span>
      <aionz-kanban-chip-badge
        class="supplier-count-badge"
        [label]="totalSuppliersCount().toString()"
        icon="storefront"
        [compact]="true"
        [aionzTooltip]="getSuppliersTooltipItems()"
        mode="message"
        [aionzTooltipDisabled]="getSuppliersTooltipItems().length === 0">
      </aionz-kanban-chip-badge>
    </div>
  </div>

  <div class="product-list">
    @for (product of data().products; track product.productCode) {
      <aionz-product-integration-accordion
        [productCode]="product.productCode"
        [productName]="product.productName"
        [ERPId]="product.ERPId"
        [orderId]="product.orderId"
        [status]="product.status"
        [errorMessage]="product.errorMessage ?? null"
        [suppliers]="product.suppliers ?? []"
        [costCenters]="product.costCenters ?? []"
        [branches]="product.branches ?? []">
      </aionz-product-integration-accordion>
    }
  </div>
</aionz-dialog-content>

<aionz-dialog-actions
  align="end"
  class="dialog-footer">
  <button
    mat-stroked-button
    (click)="close()"
    [disabled]="isLoading()">
    Fechar
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="tryAgain()"
    class="btn-primary"
    [disabled]="isLoading() || failedCount() === 0">
    @if (isLoading()) {
      <div class="flex-row items-center gap-4">
        <mat-spinner
          diameter="15"
          class="btn-spinner"></mat-spinner>
        <span>Reenviando…</span>
      </div>
    } @else {
      {{ retryLabel() }}
    }
  </button>
</aionz-dialog-actions>
